import { ContactPhone } from "./contact-phone";

export class DivisionContact {

    constructor() {
    }

    id: number;
    divisionId: number;
    name: string;
    title: string;
    verified: boolean;
    email: string;
    contactTypeId: number;
    contactType: string;
    city: string;
    state: string;
    phones: Array<ContactPhone> = [];
}
